import { t } from '@moovly/i18n';
import * as React from 'react';
import './UsersStatusSelector.scss';
import classnames from 'classnames';

export enum UserPageTab {
  Active = 'assigned',
  Inactive = 'assigned-expired',
  Disabled = 'available',
}

interface UsersStatusSelectorProps {
  status: UserPageTab;
  count: {
    [key in UserPageTab]: number;
  };
  onSelectStatus: (status: UserPageTab) => void;
}

const tabs = [
  {
    type: UserPageTab.Active,
    translationKey: 'seats.table.sectionHeaders.active',
  },
  {
    type: UserPageTab.Inactive,
    translationKey: 'seats.table.sectionHeaders.inactive',
  },
  {
    type: UserPageTab.Disabled,
    translationKey: 'seats.table.sectionHeaders.disabled',
  },
];

const UsersStatusSelector: React.FC<UsersStatusSelectorProps> = ({ status, count, onSelectStatus }) => {
  React.useEffect(() => {
    const { hash } = window.location;
    let startPage: UserPageTab | null = null;
    if (hash && hash.length && hash.includes('status-')) {
      const page = hash.replace('#status-', '');
      if (tabs.some((t) => t.type === page)) {
        startPage = page as UserPageTab;
      }
    }
    if (startPage) {
      onSelectStatus(startPage);
    }
  }, []);
  const handleSelectStatus = React.useCallback(
    (status: UserPageTab) => (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      onSelectStatus(status);
      window.location.hash = `status-${status}`;
    },
    [onSelectStatus]
  );
  return (
    <div>
      {tabs.map((tab) => (
        <button
          key={`user-status-ta${tab.type}`}
          onClick={handleSelectStatus(tab.type)}
          className={classnames('StatusSelectorTab', {
            active: status === tab.type,
          })}
        >
          {`${t(tab.translationKey)} (${count[tab.type]})`}
        </button>
      ))}
    </div>
  );
};
export default UsersStatusSelector;
